import React, { useState, useEffect, useRef } from "react";
import { isUndefined, size, map } from "lodash";
import ApiEngine from "../../util/ApiEngine";
import { useForm, Controller } from "react-hook-form";
import { useTranslation } from "react-i18next";
import {
  ApiKey, ApiUrl, SessionKey, WebUrl,
  LanguageOption,
} from "../../util/Constant";
import { stringIsNullOrEmpty, createFormBody, numberWithCommas, numberWithCurrencyFormat2, isObjectEmpty } from "../../util/Util";
import { useDispatch, useSelector } from "react-redux";
import {
  setActiveTab,
  setBusy,
  setDownlineQuery,
  setDownlineSearchText,
  setIdle,
  setPageSize,
  setY,
  showResponseMessage,
} from "../../redux/AppAction";
const ChangeShareHolderPin = (props) => {
  const { t, i18n } = useTranslation();
  const [showNewPasswordText, setShowNewPasswordText] = useState(false);
  const [showConfirmPasswordText, setShowConfirmPasswordText] = useState(false);
  const [showCurrentPasswordText, setShowCurrentPasswordText] = useState(false);
  const [checkVipPinExist, setCheckVipPinExist] = useState(true);
  const _dispatch = useDispatch();

  const {
    errors: resetPasswordErrors,
    handleSubmit: handleResetPasswordSubmit,
    watch: resetPasswordWatch,
    setValue: setResetPasswordValue,
    setError: setResetPasswordError,
    clearErrors: clearResetPasswordErrors,
    register: resetPasswordRegister,
  } = useForm();

  useEffect(() => {
    init();
  }, []);

  async function init() {
    let params = {};
    let responseJson = await ApiEngine.get(ApiUrl._API_GET_MEMBER_DETAILS_BY_ID);
    if (responseJson[ApiKey._API_SUCCESS_KEY]) {

      if (responseJson[ApiKey._API_DATA_KEY]["isShareHolder"] === true) {
        let responseJson2 = await ApiEngine.post(
          ApiUrl._API_CHECK_SHAREHOLDER_PIN_NUMBER,
          createFormBody(params)
        );

        if (!responseJson2[ApiKey._API_SUCCESS_KEY]) {
          setCheckVipPinExist(false);
        }
      }
    }
  }

  const changeShareholderPin = async (data) => {
    try {
      let params = {
        oldPinNumber: data.currentPassword,
        pinNumber: data.password,
        confirmPinNumber: data.confirmPassword,
      };

      var responseJson = await ApiEngine.post(
        ApiUrl._API_SET_SHAREHOLDER_PIN_NUMBER,
        createFormBody(params)
      );

      if (responseJson[ApiKey._API_SUCCESS_KEY]) {
        setCheckVipPinExist(true);
      }

      setResetPasswordValue("currentPassword", "");
      setResetPasswordValue("password", "");
      setResetPasswordValue("confirmPassword", "");

      _dispatch(
        showResponseMessage(
          responseJson[ApiKey._API_SUCCESS_KEY],
          responseJson[ApiKey._API_MESSAGE_KEY]
        )
      );
    } catch (err) {
      _dispatch(showResponseMessage(false, err));
    }
  };

  return (
    <>
      <form onSubmit={handleResetPasswordSubmit(changeShareholderPin)} id="changeShareholderPin">
        <div className="custom-container-box-my-profile" style={{ fontSize: '12px !important' }}>
          {checkVipPinExist &&
            <div className="withdraw-form-input">
              <div className="first">
                {t("OLD_SHAREHOLDER_PIN")} :
              </div>
              <div className="second">
                <div class="custom-input-text">
                  <div className="with-show-password-input">
                    <input
                      type={showCurrentPasswordText ? "text" : "password"}
                      name="currentPassword"
                      className="custom-input-style-1"
                      placeholder={t("OLD_SHAREHOLDER_PIN")}
                      autoComplete="off"
                      maxlength="4"
                      ref={resetPasswordRegister({
                        required: "REQUIRED_OLD_PASSWORD",
                      })}
                      value={resetPasswordWatch("currentPassword") || ""}
                      onInput={(e) => {
                        if (e.target.value === resetPasswordWatch("password")) {
                          setResetPasswordError("password", {
                            message: "NEW_PASSWORD_SAME_AS_OLD_PASSWORD",
                          });
                        } else {
                          clearResetPasswordErrors("password");
                        }
                        setResetPasswordValue("currentPassword", e.target.value);
                      }}
                      errors={resetPasswordErrors}
                    />
                    <div
                      className="image"
                      onClick={() => setShowCurrentPasswordText(!showCurrentPasswordText)}
                    >
                      <img
                        src={"/img/live-ui/eyes-show.png"}
                        className="img-responsive"
                        alt="referral-code"
                      />
                    </div>
                  </div>
                  <div className="invalid-feedback">
                    {resetPasswordErrors.currentPassword
                      ? t(resetPasswordErrors.currentPassword.message)
                      : ""}
                  </div>
                </div>
              </div>
            </div>
          }
          <div className="withdraw-form-input mt-2">
            <div className="first">
              {t("NEW_SHAREHOLDER_PIN")} :
            </div>
            <div className="second">
              <div class="custom-input-text">
                <div className="with-show-password-input">
                  <input
                    type={showNewPasswordText ? "text" : "password"}
                    name="password"
                    className="custom-input-style-1"
                    placeholder={t("NEW_SHAREHOLDER_PIN")}
                    autoComplete="off"
                    maxlength="4"
                    ref={resetPasswordRegister({
                      required: "REQUIRED_NEW_PASSWORD",
                    })}
                    value={resetPasswordWatch("password") || ""}
                    onInput={(e) => {
                      if (e.target.value === resetPasswordWatch("password")) {
                        setResetPasswordError("password", {
                          message: "NEW_PASSWORD_SAME_AS_OLD_PASSWORD",
                        });
                      } else {
                        clearResetPasswordErrors("password");
                      }
                      setResetPasswordValue("password", e.target.value);
                    }}
                    errors={resetPasswordErrors}
                  />
                  <div
                    className="image"
                    onClick={() => setShowNewPasswordText(!showNewPasswordText)}
                  >
                    <img
                      src={"/img/live-ui/eyes-show.png"}
                      className="img-responsive"
                      alt="referral-code"
                    />
                  </div>
                </div>
                <div className="invalid-feedback">
                  {resetPasswordErrors.password
                    ? t(resetPasswordErrors.password.message)
                    : ""}
                </div>
              </div>
            </div>
          </div>
          <div className="withdraw-form-input mt-2">
            <div className="first">
              {t("CONFIRM_SHAREHOLDER_PIN")}:
            </div>
            <div className="second">
              <div class="custom-input-text">
                <div className="with-show-password-input">
                  <input
                    type={showConfirmPasswordText ? "text" : "password"}
                    name="confirmPassword"
                    className="custom-input-style-1"
                    placeholder={t("CONFIRM_SHAREHOLDER_PIN")}
                    autoComplete="off"
                    maxlength="4"
                    ref={resetPasswordRegister({
                      required: "REQUIRED_CONFIRM_NEW_PASSWORD",
                    })}
                    value={resetPasswordWatch("confirmPassword") || ""}
                    onInput={(e) => {
                      if (e.target.value !== resetPasswordWatch("password")) {
                        setResetPasswordError("password", {
                          message: "PASSWORD_MISMATCH",
                        });
                      } else {
                        clearResetPasswordErrors("password");
                      }
                      setResetPasswordValue("confirmPassword", e.target.value);
                    }}
                    errors={resetPasswordErrors}

                  />
                  <div
                    className="image"
                    onClick={() => setShowConfirmPasswordText(!showConfirmPasswordText)}
                  >
                    <img
                      src={"/img/live-ui/eyes-show.png"}
                      className="img-responsive"
                      alt="referral-code"
                    />
                  </div>
                </div>
                <div className="invalid-feedback">
                  {resetPasswordErrors.confirmPassword
                    ? t(resetPasswordErrors.confirmPassword.message)
                    : ""}
                </div>
              </div>
            </div>
          </div>
          <div className="withdraw-form-input mt-2">
            <div className="first">

            </div>
            <div className="second">
              <button
                class="custom-btn-new"
                type="submit"
                disabled={Object.keys(resetPasswordErrors).length > 0}
              >
                {t("SUBMIT")}
              </button>
            </div>
          </div>
        </div>
      </form>
    </>
  )
};
export default ChangeShareHolderPin;
